// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reward-extract-tab .table td[data-v-1915a4f5] {\n  vertical-align: middle;\n}\n.reward-extract-tab .badge[data-v-1915a4f5] {\n  font-size: 0.8em;\n}\n", ""]);
// Exports
module.exports = exports;
